import { Box, Typography } from "@mui/material";
import data from "./../../Assets/data/News.json";
import NewsCard from "./NewsCard";
import { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SampleNextArrow(props) {
  const { onClick, index, maxSlide } = props;
  return index !== maxSlide - 1 ? (
    <div
      style={{
        display: "block",
        right: "0%",
        position: "absolute",
        top: "40%",
        zIndex: 8,
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <img
        src={process.env.PUBLIC_URL + "Images/Icons/NextArrow.png"}
        width="60%"
        alt="Arrow"
      />
    </div>
  ) : null;
}

function SamplePrevArrow(props) {
  const { onClick, index } = props;
  return index !== 0 ? (
    <div
      style={{
        display: "block",
        left: "2%",
        position: "absolute",
        top: "40%",
        zIndex: 8,
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <img
        src={process.env.PUBLIC_URL + "Images/Icons/PrevArrow.png"}
        width="60%"
        alt="Arrow"
      />
    </div>
  ) : null;
}

const NewsSection = () => {
  const [computedMargin, setComputedMargin] = useState();
  const [slideIndex, setSlideIndex] = useState(0);
  const marginRef = useRef(null);

  function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
  }
  const onArrowClick = (e) => {
    setSlideIndex(e);
  };
  const currentWindow = useWindowSize();
  useEffect(
    () =>
      marginRef.current
        ? setComputedMargin(
            window
              .getComputedStyle(marginRef.current)
              .getPropertyValue("margin-left")
          )
        : "",
    [currentWindow]
  );

  useEffect(() => {
    document.querySelectorAll(".slick-track").forEach((el) => {
      el.style.setProperty("margin-left", computedMargin, "important");
    });
  }, [computedMargin]);

  const sliderSettings = {
    adaptiveHeight: true,
    centerMode: false,
    dots: false,
    focusOnSelect: true,
    infinite: false,
    slidesPerRow: 1,
    speed: 500,
    swipeToSlide: true,
    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow index={slideIndex} maxSlide={data.length} />,
    prevArrow: <SamplePrevArrow index={slideIndex} />,
    afterChange: onArrowClick,
  };
  const sliderStyle = {
    width: "100%",
    position: "relative",
    height: "auto",
  };
  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "2em",
        paddingBottom: "2em",
      }}
    >
      <Box ref={marginRef} style={{ maxWidth: "960px" }}>
        <Typography fontWeight={600} fontSize="28px">
          News
        </Typography>
        <Typography
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "48px",
          }}
          fontWeight={500}
          fontSize="18px"
        >
          Latest news in the Delina Research Group
        </Typography>
        <Box
          style={{
            width: "100%",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            height: "auto",
            overflowX: "auto",
            marginTop: "2.5em",
            marginBottom: "3em",
          }}
        >
          <Slider {...sliderSettings} style={sliderStyle}>
            {data.length > 0 &&
              data.map((news, i) => {
                return <NewsCard {...news} width="30em" />;
              })}
          </Slider>
        </Box>
      </Box>
    </Box>
  );
};

export default NewsSection;
